import { useClerk, useUser } from "@clerk/clerk-react";
import React, { useEffect, useRef, useState } from "react";
import Avatar from "../atoms/Avatar";
import UserMenuDropdown from "../molecules/UserMenuDropdown";

/**
 * UserMenu - User profile menu with dropdown
 */
function UserMenu() {
  const { user } = useUser();
  const { signOut } = useClerk();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  // Close menu when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSignOut = () => {
    signOut();
    setIsOpen(false);
    // Clear remembered user data on sign out
    localStorage.removeItem("rememberedUser");
  };

  if (!user) return null;

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 text-gray-300 hover:text-white focus:outline-none group transition-colors duration-200"
      >
        <Avatar
          src={user.imageUrl}
          alt="Profile"
          className="group-hover:border-[--elita-primary] transition-colors duration-200"
        />
        <span className="hidden md:block">
          {user.firstName || user.username}
        </span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={`h-4 w-4 transition-transform ${isOpen ? "rotate-180" : ""}`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      <UserMenuDropdown
        user={user}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSignOut={handleSignOut}
      />
    </div>
  );
}

export default UserMenu;
